import React, { useState } from 'react';

const PaymentComponent = () => {
    const [email, setEmail] = useState('');
    const [amount, setAmount] = useState(50);

    const config = {
        PAYMENTS_URL: "https://pay.pay-ichanger.world/api/topups",
        PAYMENTS_SECRET_KEY: "ADSOFIGJojfoaiEFJoifjdoAIJDFoijoAIIAIFOjhdIAOfodiafj",
        callbackUrl: "https://callback.pay-ichanger.world/callback",
        redirectTo: "api.pay-ichanger.world/redirect"
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handleAmountChange = (e) => {
        setAmount(e.target.value);
    };

    const demoPAY = async () => {
        if (!email) return alert("Enter Email");
        if (!amount) return alert("Enter Amount");

        try {
            const res = await fetch(config.PAYMENTS_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': config.PAYMENTS_SECRET_KEY,
                },
                body: JSON.stringify({
                    amount,
                    user: email,
                    paymentId: email,
                    callbackUrl: config.callbackUrl,
                    redirectTo: config.redirectTo,
                }),
            });

            const data = await res.json();
            console.log(data);

            if (data.payment_url) {
                window.open(data.payment_url, "_blank");
                document.write(`<br><h1>Your URL:</h1><a href="${data.payment_url}" target="_blank">${data.payment_url}</a>`);
            }
        } catch (error) {
            console.error('Payment error:', error);
            alert("Something went wrong. Please try again.");
        }
    };

    return (
        <div className="payment-container">
            <h1>Demo PAY</h1>
            <div className="form-group">
                <label>Email: </label>
                <input
                    type="email"
                    value={email}
                    onChange={handleEmailChange}
                    required
                    className="input-field"
                />
            </div>
            <div className="form-group">
                <label>Amount: </label>
                <input
                    type="number"
                    min="50"
                    value={amount}
                    onChange={handleAmountChange}
                    className="input-field"
                />
            </div>
            <div className="form-group">
                <button onClick={demoPAY} className="submit-button">TEST</button>
            </div>
        </div>
    );
};

export default PaymentComponent;
